// Components==============
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import './ArrowButton.module.scss';
// =========================

export default function ArrowButton({
    handleClick,
    answerIsCorrect,
    isAnswered,
    background,
}: {
    handleClick: () => void;
    answerIsCorrect: boolean;
    isAnswered: boolean;
    background: Background;
}) {
    const wrongColor = !isAnswered
        ? '#ffffff'
        : background === 'desert'
        ? '#AD9993'
        : '#ffffff';

    return (
        <motion.button
            type="button"
            onClick={handleClick}
            animate={{
                background: answerIsCorrect ? '#16D872' : wrongColor,
                opacity:
                    background === 'desert'
                        ? 1
                        : !answerIsCorrect && isAnswered
                        ? 0.4
                        : 1,
                color: answerIsCorrect ? '#ffffff' : '#bdccd4',
            }}
            initial={{ background: '#ffffff', opacity: 0, color: '#bdccd4' }}
            exit={{
                background: answerIsCorrect ? '#16D872' : wrongColor,
                opacity: 0,
                color: answerIsCorrect ? '#ffffff' : '#bdccd4',
            }}
            styleName="button"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
        >
            <FontAwesomeIcon
                icon={faArrowUp}
                style={{
                    opacity:
                        background === 'desert'
                            ? isAnswered && !answerIsCorrect
                                ? 0.4
                                : 1
                            : 1,
                }}
            />
        </motion.button>
    );
}
